'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UIAvatarMultiOrSingle from './UIAvatarMultiOrSingle';
import devLogger from 'react-utils/devLogger';
import { AVATAR_SIZES } from './Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const avatarSizeBackwardsCompat = {
  'extra-small': 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  'extra-large': 'xl'
};

// This file is now just going to absorb the API changes from v1 to
// v2 so we can be waaaay cleaner down the line
class UIAvatar extends Component {
  companyWithWarning(company) {
    if (company) {
      devLogger.warn({
        message: 'there is no company prop, maybe you mean domain or companyId'
      });
    }
  }
  sizeWithWarning(size) {
    const checkedAvatarSize = avatarSizeBackwardsCompat[size];
    if (checkedAvatarSize) {
      devLogger.warn({
        message: 'Old size prop values are supplied, please use 2 letter sizes instead'
      });
      return checkedAvatarSize;
    }
    return size;
  }
  lookupWithWarning(lookup, lookups, avatarLookup) {
    const oldLookup = lookups || avatarLookup;
    if (oldLookup) {
      devLogger.warn({
        message: 'lookups and avatarLook up deprecated props, please just use lookup'
      });
      return lookup || oldLookup;
    }
    return lookup;
  }
  hubSpotUserEmailWithWarning(hubSpotUserEmail, hubspotUserEmail) {
    if (hubspotUserEmail) {
      devLogger.warn({
        message: 'I think you meant hubSpotUserEmail (S vs s)'
      });
    }
    return hubSpotUserEmail || hubspotUserEmail;
  }
  maxAvatarsWithWarning(maxAvatars, totalNumOfAvatars) {
    if (totalNumOfAvatars) {
      devLogger.warn({
        message: 'totalNumOfAvatars is deprecated, please use maxAvatars instead'
      });
      return maxAvatars || totalNumOfAvatars;
    }
    return maxAvatars;
  }
  catchWeirdProps() {
    const {
      _isHoverlayOpen,
      _isHasTooltip,
      _toolTipOverWrite,
      _noDefaultSrc,
      _truncateAvatarListInTooltip,
      avatarLookup,
      avatarType,
      childClassName,
      children,
      childStyles,
      className,
      companyId,
      displayName,
      company,
      domain,
      email,
      existsInPortal,
      fetchAvatars,
      fileManagerKey,
      hasMoreHref,
      href,
      hubspotUserEmail,
      hubSpotUserEmail,
      isHoverlay,
      lookup,
      lookups,
      maxAvatars,
      onClick,
      productId,
      portalId,
      size,
      socialNetwork,
      src,
      style,
      toolTipPlacement,
      totalNumOfAvatars,
      type,
      textSpacing,
      truncateLength,
      vid
    } = this.props;

    // avatarRenderer
    // backgroundcolor
    // color
    // name …only social is using UIAvatarIcon and that's depricated now.
    // https://private.hubteamqa.com/opengrok/search?q=%22%3CUIAvatarIcon%22&defs=&refs=&path=&hist=&type=&project=all
    // Shape

    // Warnings
    // size needs to be
    // lookups
    // avatarLookup

    return {
      _isHoverlayOpen,
      _isHasTooltip,
      _toolTipOverWrite,
      _noDefaultSrc,
      _truncateAvatarListInTooltip,
      childClassName,
      children,
      childStyles,
      className,
      company: this.companyWithWarning(company),
      companyId,
      displayName,
      domain,
      email,
      existsInPortal,
      fetchAvatars,
      fileManagerKey,
      hasMoreHref,
      href,
      hubSpotUserEmail: this.hubSpotUserEmailWithWarning(hubSpotUserEmail, hubspotUserEmail),
      isHoverlay,
      lookup: this.lookupWithWarning(lookup, lookups, avatarLookup),
      maxAvatars: maxAvatars || totalNumOfAvatars,
      onClick,
      productId,
      portalId,
      size: this.sizeWithWarning(size),
      socialNetwork,
      src,
      style,
      type: type || avatarType,
      textSpacing,
      truncateLength,
      vid,
      toolTipPlacement
    };
  }
  render() {
    return /*#__PURE__*/_jsx(UIAvatarMultiOrSingle, Object.assign({}, this.catchWeirdProps(this.props)));
  }
}
UIAvatar.displayName = 'UIAvatar';
UIAvatar.propTypes = {
  lookups: PropTypes.any,
  avatarLookup: PropTypes.any,
  totalNumOfAvatars: PropTypes.number,
  avatarType: PropTypes.string,
  _truncateAvatarListInTooltip: PropTypes.bool,
  _isHoverlayOpen: PropTypes.bool,
  _isHasTooltip: PropTypes.bool,
  _toolTipOverWrite: PropTypes.bool,
  _noDefaultSrc: PropTypes.bool,
  authed: PropTypes.bool,
  childClassName: PropTypes.string,
  children: PropTypes.node,
  childStyles: PropTypes.object,
  className: PropTypes.string,
  company: PropTypes.string,
  companyId: PropTypes.number,
  displayName: PropTypes.string,
  domain: PropTypes.string,
  email: PropTypes.string,
  existsInPortal: PropTypes.bool,
  fetchAvatars: PropTypes.func,
  fileManagerKey: PropTypes.string,
  hasMoreHref: PropTypes.string,
  href: PropTypes.string,
  hubspotUserEmail: PropTypes.string,
  hubSpotUserEmail: PropTypes.string,
  isHoverlay: PropTypes.bool,
  lookup: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  maxAvatars: PropTypes.number,
  onClick: PropTypes.func,
  productId: PropTypes.number,
  portalId: PropTypes.number,
  size: PropTypes.oneOf(Object.keys(AVATAR_SIZES)),
  socialNetwork: PropTypes.string,
  src: PropTypes.string,
  style: PropTypes.object,
  toolTipPlacement: PropTypes.string,
  type: PropTypes.string,
  textSpacing: PropTypes.number,
  truncateLength: PropTypes.number,
  vid: PropTypes.number
};
export default UIAvatar;
export const WEBPACK_3_FORCE_MODULE_IMPORT = 1;